module.exports = __webpack_public_path__ + "f0c59b43c1c788af000437830dbea0b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/galaxy.svg
// module id = 20
// module chunks = 0 1